import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select, ToolTip } from '@driftt/tide-core-legacy'
import { pathOr, uniqBy } from 'ramda'
import debounce from 'lodash.debounce'

const SEARCH_DEBOUNCE_TIMEOUT = 500

class PardotProspectCampaignInput extends Component {
  static propTypes = {
    fetchCampaigns: PropTypes.func.isRequired,
    searchCampaigns: PropTypes.func.isRequired,
    getPardotConfig: PropTypes.func.isRequired,
    setProspectCampaignField: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      mappedProspectCampaignValue: '',
      selectOptions: [],
      responseOptions: [],
      isLoading: false
    }

    this.saveProspectCampaignValue = debounce(this._saveProspectCampaignValue, 1000)
  }

  componentDidMount() {
    this.getProspectCampaignValue()
    this.getFieldOptions()
  }

  getProspectCampaignValue = async () => {
    const { getPardotConfig } = this.props

    const config = await getPardotConfig()

    let mappedProspectCampaignValue = undefined
    if (config.prospectCampaign) {
      // Serialize for unique value identifier of campaign.
      mappedProspectCampaignValue = JSON.stringify(config.prospectCampaign)
    }

    this.setState({
      mappedProspectCampaignValue
    })
  }

  formatCampaign = campaign => ({ label: campaign.name, value: JSON.stringify(campaign)})

  getFieldOptions = async () => {
    const { fetchCampaigns } = this.props

    const data = await fetchCampaigns()
    if (data.err) {
      console.error(data.err)
      return
    }

    const campaigns = pathOr([], ['result', 'campaign'], data)

    const options = campaigns.map(this.formatCampaign)

    this.setState({
      selectOptions: options,
    })
  }

  searchPardotCampaigns = async (name) => {
    const {searchCampaigns} = this.props
    if (name.length <= 2) {
      return
    }

    this.setState({isLoading: true})
    try {
      const response = await searchCampaigns(name)
      this.setState({
        isLoading: false,
        responseOptions: response.result.campaign.map(this.formatCampaign)
      })
    } catch(e) {
      console.error(e)
      this.setState({
        isLoading: false,
        responseOptions: []
      })
    }
  }

  debouncedSearch = _.debounce(this.searchPardotCampaigns, SEARCH_DEBOUNCE_TIMEOUT)

  _saveProspectCampaignValue = async () => {
    const { onSuccess, setProspectCampaignField } = this.props
    const { mappedProspectCampaignValue } = this.state
    if (!mappedProspectCampaignValue) {
      return
    }

    try {
      await setProspectCampaignField(JSON.parse(mappedProspectCampaignValue))
      onSuccess()
    } catch(e) {
      console.error(e)
    }
  }

  handleSelectChange = selectedOption => {
    let newProspectCampaignValue

    const selectionCleared = !selectedOption
    if (selectionCleared) {
      newProspectCampaignValue = undefined
    } else {
      newProspectCampaignValue = selectedOption.value
    }

    this.setState({
      mappedProspectCampaignValue: newProspectCampaignValue
    }, this.saveProspectCampaignValue)
  }

  render() {
    const { mappedProspectCampaignValue, isLoading, responseOptions, selectOptions } = this.state
    const disabled = !this.props.isEnabled
    let unfilteredOptions = [...responseOptions, ...selectOptions]
    if (mappedProspectCampaignValue) {
      const selectedOption = JSON.parse(mappedProspectCampaignValue)
      unfilteredOptions.push(this.formatCampaign(selectedOption))
    }
    const allCampaignOptions = uniqBy(c => c.value, unfilteredOptions)

    return (
      <Select 
        className={'pardot-prospect-campaign-select'}
        options={allCampaignOptions}
        value={mappedProspectCampaignValue}
        disabled={disabled}
        onChange={this.handleSelectChange}
        autosize={true}
        isLoading={isLoading}
        onInputChange={this.debouncedSearch}
      />
    )
  }
}

export default PardotProspectCampaignInput


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotConfig/PardotProspectCampaignInput.js